// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__mQBVi","modal-content":"styles_modal-content__dz37z","modal-close":"styles_modal-close__of4Ou","modal-header":"styles_modal-header__24Gsf"};